<div class="pt-3 pl-md-4" *ngIf="!accountService.getMyAccount().can_manage_members">
  <h2>You do not have permission to manage customers.</h2>
</div>

<div class="pt-3 pl-md-4" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="pt-3 pl-md-4"
     *ngIf="accountService.getMyAccount().can_manage_members && serverError === null">

  <h2>Create Bookings</h2>

  <p>
    This will book the <b>{{ customerIdCount }}</b> selected customers onto an event, bypassing any fees, add-ons,
    additional participant questions, and capacity limits that pertain to the selected event.
  </p>

  <form (submit)="handleSubmit()">

    <div class="row">
      <div class="form-group col-12 col-sm-8 col-md-6 col-xl-4">
        <label for="eventTypeSelect">Event Type</label>
        <select id="eventTypeSelect" class="custom-select" name="eventType"
                [(ngModel)]="selectedEventType" (ngModelChange)="loadEventsForDate()"
                [disabled]="loadingSubmit"
                [class.disabled]="loadingSubmit"
                *ngIf="!loadingEventTypes" required>
          <option [ngValue]="null" disabled>-- Select an Event Type --</option>
          <option *ngFor="let eventType of eventTypeList.results"
                  [ngValue]="eventType">
            {{ eventType.name }}
          </option>
        </select>
        <select id="eventTypeSelectLoading" class="custom-select" name="eventType"
                *ngIf="loadingEventTypes" disabled>
          <option selected>Loading...</option>
        </select>
      </div>
    </div>

    <ng-container *ngIf="selectedEventType && !loadingSelectedEvent && !selectedEvent">

      <p>Select a Time Slot</p>

      <div class="mb-2">
        <app-date-picker [id]="'selectedDate'"
                         [(content)]="selectedDate"
                         (contentChange)="loadEventsForDate()"
                         [small]="true"></app-date-picker>
      </div>

      <div class="rounded-table-wrapper rounded-table-tight">
        <table class="table table-sm">
          <thead>
          <tr>
            <th scope="col">Time</th>
            <th scope="col">Reservations / Capacity</th>
            <th scope="col"></th>
          </tr>
          </thead>
          <tbody>
          <ng-container *ngIf="!loadingEventsForDate">
            <tr *ngFor="let scheduledEvent of scheduledEventsForDate">
              <td>
                {{ timeStringFromISO8601(scheduledEvent.start_datetime, scheduledEvent.time_zone) }} -
                {{ timeStringFromISO8601(scheduledEvent.end_datetime, scheduledEvent.time_zone) }}
                <span *ngIf="scheduledEvent.is_cancelled">&ndash; <b>Cancelled</b></span>
                <ng-container *ngIf="scheduledEvent.event_part_count > 1">
                  (Part {{ scheduledEvent.event_part_number }} of {{ scheduledEvent.event_part_count }})
                </ng-container>
                <br>
                <i>{{ scheduledEvent.location_name }}</i>
              </td>
              <td>
                {{ scheduledEvent.reservation_count }} / {{ scheduledEvent.capacity }}
              </td>
              <td class="table-sm-button-cell">
                <button class="btn btn-sm btn-outline-primary table-sm-button float-right"
                        type="button"
                        (click)="loadSelectedEvent(scheduledEvent.event_id)">
                  Select Time Slot
                </button>
              </td>
            </tr>
            <tr *ngIf="scheduledEventsForDate.length === 0">
              <td colspan="99">No time slots for the selected date</td>
            </tr>
          </ng-container>
          <tr *ngIf="loadingEventsForDate">
            <td colspan="99">Loading...</td>
          </tr>
          </tbody>
        </table>
      </div>

    </ng-container>

    <ng-container *ngIf="loadingSelectedEvent">
      <p class="text-muted">
        Loading event...
      </p>
    </ng-container>

    <ng-container *ngIf="selectedEventType && !loadingSelectedEvent && selectedEvent">
      <button class="btn btn-sm btn-link float-right" style="margin-top: -6px"
              type="button"
              [disabled]="loadingSubmit"
              [class.disabled]="loadingSubmit"
              (click)="selectedEvent = null">
        Clear Selection
      </button>

      <ng-container *ngIf="selectedEvent.event_parts.length === 1">
        <p>
          Selected Event at {{ selectedEvent.location_name }}:
          <b>
            {{ selectedEvent.event_parts[0].start_local_date }},
            {{ selectedEvent.event_parts[0].start_local_time }} -
            {{ selectedEvent.event_parts[0].end_local_time }}
          </b>
        </p>
      </ng-container>
      <ng-container *ngIf="selectedEvent.event_parts.length > 1">
        <p class="mb-1">Selected multi-part event at {{ selectedEvent.location_name }}:</p>
        <ul>
          <li *ngFor="let eventPart of selectedEvent.event_parts">
            <b>
              {{ eventPart.start_local_date }},
              {{ eventPart.start_local_time }} -
              {{ eventPart.end_local_time }}
            </b>
          </li>
        </ul>
      </ng-container>
    </ng-container>

    <div class="form-group form-check">
      <input type="checkbox" class="form-check-input"
             id="sendConfirmationEmails" name="sendConfirmationEmails"
             [(ngModel)]="sendConfirmationEmails">
      <label class="form-check-label" for="sendConfirmationEmails">
        Send reservation confirmation emails
      </label>
    </div>

    <div class="alert alert-danger" role="alert" *ngIf="errors.non_field_errors">
      {{ errors.non_field_errors }}
    </div>
    <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
      {{ errorMessage }}
    </div>

    <ng-container *ngIf="loadingSubmit">
      <div class="alert alert-info" role="alert">
        Creating Bookings...
      </div>

      <div class="progress">
        <div class="progress-bar" role="progressbar" [style]="{width: getProgressPercentageStr() + '%'}"
             attr.aria-valuenow="{{ getProgressPercentageStr() }}" aria-valuemin="0" aria-valuemax="100"></div>
      </div>
    </ng-container>

    <!-- Place save button first so that the enter key press activates it -->
    <div class="mt-5">
      <div class="float-right">
        <button type="submit" class="btn btn-primary"
                [disabled]="isLoading() || !allInputsSelected()"
                [class.disabled]="isLoading() || !allInputsSelected()">
          {{ isLoading() ? 'Loading' : 'Create Bookings' }}
        </button>
      </div>
      <button routerLink="/customers"
              type="button"
              [disabled]="isLoading()"
              [class.disabled]="isLoading()"
              class="btn btn-secondary">
        Cancel
      </button>
    </div>

  </form>

</div>
